
export default {
  name: 'NotFound'
}
